const mapDispatchToMethods = (context, storeModule, dispatch, actionsList) => {
  actionsList.forEach((actionName) => {
    if (actionName in storeModule && typeof storeModule[actionName] === 'function') {
      Object.defineProperty(context, actionName, {
        value: (...args) => dispatch(storeModule[actionName](...args)),
        writable: true,
        configurable: true
      })
    } else {
      throw new Error(`No such action "${actionName}" in the store slice "${storeModule.default.name}"`);
    }
  });
};

export default mapDispatchToMethods;